import { useQuery } from '@tanstack/react-query';
import { getTimeline, type TimelineEvent } from '@/features/projects/projects-api';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { statusLabels } from '@/features/projects/labels';
import type { ProjectStatus } from '@bcl/shared';

function formatDate(iso: string): string {
  return new Date(iso).toLocaleString('fr-FR');
}

export function Timeline({ projectId }: { projectId: string }) {
  const q = useQuery<TimelineEvent[]>({
    queryKey: ['timeline', projectId],
    queryFn: () => getTimeline(projectId),
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle>Suivi du dossier</CardTitle>
      </CardHeader>
      <CardContent>
        {q.isLoading ? (
          <p className="text-sm text-muted-foreground">Chargement…</p>
        ) : !q.data || q.data.length === 0 ? (
          <p className="text-sm text-muted-foreground">
            Aucun événement pour le moment.
          </p>
        ) : (
          <ol className="space-y-3">
            {q.data.map((e) => (
              <li key={e.id} className="flex items-start gap-3 text-sm">
                <span className="text-muted-foreground">{formatDate(e.createdAt)}</span>
                <span>
                  <strong>{statusLabels[e.status as ProjectStatus]}</strong>
                  {e.message ? ` — ${e.message}` : ''}
                </span>
              </li>
            ))}
          </ol>
        )}
      </CardContent>
    </Card>
  );
}
